import React from "react";
import Format from "../../../helpers/Format";
import PropTypes from "prop-types";

function DadosNFSe({ dadosNota, valuesHook }) {
  const { values } = valuesHook;

  return (
    <>
      <div className="row" style={{ fontSize: "12px" }}>
        <div className="col-12 mb-2">
          <h6 className="mb-0">Dados do cliente</h6>
          <span>
            {dadosNota?.razao_social && dadosNota?.razao_social.toUpperCase()}
          </span>
          <span>
            {dadosNota?.cnpj && ` - ${dadosNota?.cnpj.toUpperCase()}`}
          </span>
          <br />
          <span className="pe-2">
            {dadosNota?.logradouro && dadosNota?.logradouro.toUpperCase()}
          </span>
          <span className="pe-2">
            {dadosNota?.numero && dadosNota?.numero.toUpperCase()}
          </span>
          <span>
            {dadosNota?.complemento && dadosNota?.complemento.toUpperCase()}
          </span>
          <br />
          <span className="pe-2">
            {dadosNota?.bairro && dadosNota?.bairro.toUpperCase()}
          </span>
          <span>{dadosNota?.cidade && dadosNota?.cidade.toUpperCase()}</span>
          <br />
          <span className="pe-2">
            {dadosNota?.cep && dadosNota?.cep.toUpperCase()}
          </span>
          <span>{dadosNota?.uf && dadosNota?.uf.toUpperCase()}</span>
          <br />
          <span>
            {dadosNota?.codigoCidade && dadosNota?.codigoCidade.toUpperCase()}
          </span>
        </div>
        <div
          className="col-12 mb-4"
          style={{ fontSize: "13px", fontWeight: "500" }}
        >
          <span>Município de incidência</span>
          <br />
          <span>{dadosNota?.cidadeIncidencia}</span>
          <span>
            {dadosNota?.ufIncidencia &&
              ` - ${dadosNota?.ufIncidencia.toUpperCase()}`}
          </span>
        </div>
        <div className="col-12 mb-2">
          <span style={{ fontSize: "13px", fontWeight: "500" }}>Descrição</span>
          <br />
          <span>{dadosNota?.descricaoServicoPrestado}</span>
        </div>
        {dadosNota?.cnpj !== "99999999999" ? (
          <div className="col-12 mb-2">
            <span
              style={{ fontSize: "13px", fontWeight: "500" }}
              className="pe-2"
            >
              Alíquota ISS:
            </span>
            {dadosNota?.aliquota && dadosNota?.aliquota !== 0
              ? `${Format.formataDecimal(dadosNota?.aliquota)}%`
              : null}
          </div>
        ) : null}

        {values?.iss && values?.iss !== 0 ? (
          <div className="col-12 mb-2">
            <span
              style={{ fontSize: "13px", fontWeight: "500" }}
              className="pe-2"
            >
              ISS retido:
            </span>
            {values?.iss && Format.formataValor(values?.iss)}
          </div>
        ) : null}
        {dadosNota?.deducoes && dadosNota?.deducoes !== 0 ? (
          <div className="col-12 mb-2">
            <span
              style={{ fontSize: "13px", fontWeight: "500" }}
              className="pe-2"
            >
              Deduções:
            </span>
            {dadosNota?.deducoes && Format.formataValor(dadosNota?.deducoes)}
          </div>
        ) : null}
        <div className="col-12 mb-2">
          <span
            className="pe-2"
            style={{ fontSize: "13px", fontWeight: "500" }}
          >
            Total da nota:
          </span>
          {dadosNota?.totalNota && dadosNota?.totalNota !== 0
            ? Format.formataValor(dadosNota?.totalNota)
            : null}
        </div>
        <div className="col-12 mb-2">
          <span
            className="pe-2"
            style={{ fontSize: "15px", fontWeight: "800" }}
          >
            Total líquido:
          </span>
          {dadosNota?.totalLiquido && !isNaN(dadosNota?.totalLiquido)
            ? Format.formataValor(dadosNota?.totalLiquido)
            : ""}
        </div>
      </div>
    </>
  );
}

DadosNFSe.propTypes = {
  dadosNota: PropTypes.object.isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
  }).isRequired,
};

export default DadosNFSe;
